import { type FC } from "react";
import { type Moment } from "moment";
import Duration from "../../../Common/Duration/Duration";
import { cache } from "../../../Utilities/Platform/CDN";

export interface LoginNewsItemType {
    date: Moment;
    image: string | false;
    text: string;
    url: string;
}

export const LoginNewsItem: FC<LoginNewsItemType> = ({
    date,
    image,
    text,
    url,
}) => {
    let src = image;

    if(typeof src !== "string") {
        src = cache("/imgs/general/news/unknown.png");
    }

    return (
        <div className="h-full overflow-hidden relative">
            <img
                src={src}
                alt={text}
                className="w-full h-full object-cover"
            />
            <div className="absolute left-0 right-0 bottom-0  bg-black/80 box-border p-6">
                <div className="overflow-hidden text-ellipsis whitespace-pre text-white text-2xl">
                    {text}
                </div>
                <div className="mb-3 text-gray-400">
                    <Duration
                        uppercase
                        timestamp={date}
                    />
                </div>
                <a
                    href={url}
                    className="text-blue-500 no-underline hover:underline mb-2"
                >
                    More Info...
                </a>
            </div>
        </div>
    );
};
